<template>
  <div class="m-wap">
    <router-view></router-view>
  </div>
</template>

<script>
import configMixin from "@/mixin/config";
import { common } from "@/model/common";

export default {
  name: "wap",
  mixins: [configMixin],
  methods: {},
  created() {},
  mounted() {
    common.platform = "wap";
    // console.log("父组件渲染了");
  },
};
</script>
